import { ActionResponse } from 'src/app/models/action-response';
import { ReplaceProductServiceDueDatesStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/init-step/due-dates-step';
import { ReplaceProductServiceInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/init-step/init-step';
import { ReplaceProductServiceBillingStep26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/replace-product-service-billing-step/replace-product-service-billing-step-v26';
import { ReplaceProductServiceRequestV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/replace-product-service-confirm-step/replace-product-service-request-v26';
import { ReplaceProductServiceReplacementStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/replace-product-service-replacement-step/replace-product-service-replacement-step-v26';

export interface State {
  initStep: ReplaceProductServiceInitStepV26;
  dueDatesStep: ReplaceProductServiceDueDatesStepV26;
  replacementStep: ReplaceProductServiceReplacementStepV26;
  billingStep: ReplaceProductServiceBillingStep26;
  request: ReplaceProductServiceRequestV26;
  response: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  initStep: null,
  dueDatesStep: { activationDate: null },
  replacementStep: null,
  billingStep: null,
  request: null,
  response: null,
  errorMessage: null,
};
